import { Injectable, inject } from '@angular/core';
import {
  CanActivate,
  CanActivateChild,
  CanMatch,
  Route,
  Router,
  UrlSegment,
  UrlTree,
} from '@angular/router';
import { getKeycloakInstance } from '@shared/utils/keycloak/app.init';
import { KeycloakConfig } from '@shared/guards/keycloak/keycloak.config';
import { SessionStorageService } from '@nequi/design-system-lib/logic';

@Injectable({
  providedIn: 'root',
})
export class KeycloakGuard implements CanActivate, CanActivateChild, CanMatch {
  private readonly router = inject(Router);
  private readonly sessionStorageService = inject(SessionStorageService);

  public canActivate(): Promise<boolean | UrlTree> {
    return this.checkAuth();
  }

  public canActivateChild(): Promise<boolean | UrlTree> {
    return this.checkAuth();
  }

  public canMatch(route: Route, segments: UrlSegment[]): Promise<boolean | UrlTree> {
    return this.checkAuth();
  }

  private async checkAuth(): Promise<boolean | UrlTree> {
    const pendingRedirect = this.sessionStorageService.getItem('fwdUrl') as string;

    if (pendingRedirect) {
      return true;
    }

    const keycloak = getKeycloakInstance();

    if (keycloak?.token) {
      await keycloak.updateToken(KeycloakConfig.minValidity);
      return true;
    }

    const trazabilityCode = sessionStorage.getItem(KeycloakConfig.trazabilityCode);
    const ticketId = sessionStorage.getItem(KeycloakConfig.ticketId);

    return this.router.createUrlTree([KeycloakConfig.loginPath], {
      queryParams: {
        trazabilityCode,
        ticketId,
      },
    });
  }
}
